<div class="brand-offer-sec">
    <div id="bannerCarousel" class="bannerCarousel">
        <owl-carousel-o [options]="customOptionsForBanner">
            <ng-container *ngFor="let data of bannerList.data">
                <ng-template carouselSlide [id]="data?.id">
                    <a (click)="GetTest(data)"
                        [ngStyle]="{'cursor': data?.banner_link ? 'pointer ': 'not-allowed' }">
                        <div class="top-banner-wrapper">
                            <img [src]="bannerList?.cfrnt_url + data?.path"
                            [alt]="data?.title" class="active" alt="banner_image" [loading]="lazy">
                        </div>
                    </a>
                </ng-template>
            </ng-container>
        </owl-carousel-o>

    </div>
    <div class="buy-can-trust-sec bg-cryan pt-5 pb-5">
      <div class="container">
          <div class="content-heading d-flex align-items-center justify-content-between mb-4">
              <h1 class="fw-semibold cv-text-dark">Avail Loan in 4 easy steps exclusive for you</h1>

          </div>
          <div class="row">
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                  <div class="content">
                      <div class="icon mb-3">
                          <img [src]="environment1 + 'images/new-images/01arrow.svg'" alt="01 arrow" loading="lazy">
                      </div>
                      <h3 class="cv-text-dark fw-semibold fs-4">Opt for finance </h3>
                      <p class="cv-text-dark-gray">While booking the vehicle select the finance option available</p>
                  </div>

              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                  <div class="content">
                      <div class="icon mb-3">
                          <img [src]="environment1 + 'images/new-images/02arrow.svg'" alt="02 arrow" loading="lazy" >
                      </div>
                      <h3 class="cv-text-dark fw-semibold fs-4">Verify your details</h3>
                      <p class="cv-text-dark-gray">Fill in and verify all the necessary details for the finance
                          options
                      </p>
                  </div>

              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                  <div class="content">
                      <div class="icon mb-3">
                          <img [src]="environment1 + 'images/new-images/03arrow.svg'" alt="03 arrow" loading="lazy" >
                      </div>
                      <h3 class="cv-text-dark fw-semibold fs-4">Select Loan Offer</h3>
                      <p class="cv-text-dark-gray">Choose an offer from the list of various offers available</p>
                  </div>

              </div>
              <div class="col-12 col-sm-12 col-md-6 col-lg-3 col-xl-3 col-xxl-3 box">
                  <div class="content">
                      <div class="icon mb-3">
                          <img [src]="environment1 + 'images/new-images/04arrow.svg'" alt="04 arrow" loading="lazy" >
                      </div>
                      <h3 class="cv-text-dark fw-semibold fs-4">Get Loan</h3>
                      <p class="cv-text-dark-gray">Once your finance gets approved, the loan disbursal process is
                          initiated</p>
                  </div>

              </div>
          </div>
      </div>
  </div>
    <div class="stripe-sec">
        <div class="container">
            <div class="row g-5">
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-1.png"' class="img-fluid" alt="ic-1" loading="lazy">
                        </div>
                        <div class="content">MINIMAL DOCUMENTATION</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-2.png"' class="img-fluid" alt="ic-2" loading="lazy">
                        </div>
                        <div class="content">Up to 100% Funding</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-3.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">MULTIPLE FINANCERS AVAILABLE</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-4.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">Apply & Process Loan Online</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-5.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">Instant Approval</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-6.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">HIGHER LOAN AMOUNT</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-7.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">Attractive Interest Rate</div>
                    </div>
                </div>
                <div class="col-12 col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-3">
                    <div class="d-flex align-items-center item-list">
                        <div class="icon-img">
                            <img [src]='environment1 + "assets/images/ic-8.png"' class="img-fluid" alt="" loading="lazy">
                        </div>
                        <div class="content">Lowest EMI</div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="finance-offer-form mt-2 mb-2">
        <h2>Finance Offers Enquiry</h2>
        <form [formGroup]="financeForm" (ngSubmit)="onSubmitFinanceOffers()">
          <div class="form-row">
            <div class="form-group">
              <label for="firstName">First Name <span style="color: red;">*</span></label>
              <input
                type="text"
                id="firstName" (input)="validateAlphabets($event)"
                formControlName="firstName"
                placeholder="Enter your first name" (input)="onInput($event)"
                required
              />
              <div *ngIf="submitted && f['firstName'].errors">
                <small style="color: red;">First name is required.</small>
              </div>
            </div>

            <div class="form-group">
              <label for="lastName">Last Name <span style="color: red;">*</span></label>
              <input
                type="text"
                id="lastName" (input)="validateAlphabets($event)"
                formControlName="lastName"
                placeholder="Enter your last name" (input)="onInput($event)"
                required
              />
              <div *ngIf="submitted && f['lastName'].errors">
                <small style="color: red;">Last name is required.</small>
              </div>
            </div>

            <div class="form-group">
              <label for="pincode">Pincode <span style="color: red;">*</span></label>
              <input
                type="text"
                id="pincode"
                formControlName="pincode"
                placeholder="Enter your pincode"
                maxlength="6"
                required
                inputmode="numeric"
                pattern="[0-9]*"
                (keypress)="allowOnlyNumbers($event)"
                (input)="addressByPincode()"
              />
              <div *ngIf="submitted && f['pincode'].errors">
                <small style="color: red;" *ngIf="f['pincode'].errors['required']">
                  Pincode is required.
                </small>
                <small style="color: red;" *ngIf="f['pincode'].errors['minlength'] || f['pincode'].errors['maxlength']">
                  Pincode must be 6 digits long.
                </small>
                <small style="color: red;" *ngIf="f['pincode'].errors['pattern']">
                  Please enter a valid 6-digit pincode.
                </small>
              </div>
            </div>


          </div>

          <div class="form-row">
            <div class="form-group">
              <label for="state">State <span style="color: red;">*</span></label>
              <input
                type="text"
                id="state"
                formControlName="state"
                placeholder="Enter your state"
                [attr.disabled]="true"

              />
              <div *ngIf="submitted && f['state'].errors">
                <small style="color: red;">State is required.</small>
              </div>
            </div>

            <div class="form-group">
              <label for="district">District <span style="color: red;">*</span></label>
              <input
                type="text"
                id="district"
                formControlName="district"
                placeholder="Enter your district"
                [attr.disabled]="true"
              />
              <div *ngIf="submitted && f['district'].errors">
                <small style="color: red;">District is required.</small>
              </div>
            </div>

            <div class="form-group">
              <label for="mobileNumber">Mobile Number <span style="color: red;">*</span></label>
              <input
                type="tel"
                id="mobileNumber"
                formControlName="mobileNumber"
                placeholder="Enter your mobile number"
                (keypress)="allowOnlyNumbers($event)"
                maxlength="10"
                required
              />
              <div *ngIf="submitted && f['mobileNumber'].errors">
                <small style="color: red;">Please enter a valid 10-digit mobile number.</small>
              </div>
              <div class="error-message" *ngIf="hasPatternError('mobileNumber')">
                *Invalid Mobile No.
              </div>
            </div>
          </div>

          <div class="form-row">

            <div class="form-group col-4" >
                <div class="form-group" *ngIf="showOtpField">
                    <label for="otp">Enter OTP<span style="color: red;">*</span></label>
                    <input
                      type="text"
                      id="otp"
                      formControlName="otp"
                      placeholder="Enter OTP"
                      maxlength="6"
                      (keypress)="allowOnlyNumbers($event)"
                      (input)="checkOtpValue($event.target.value)"

                    />
                    <p
                    *ngIf="verificationMessage"
                    [style.color]="isOtpVerified ? 'green' : 'red'"
                  >
                    {{ verificationMessage }}
                  </p>


                </div>

            </div>
            <div class="form-group col-4" style="margin-top: 24px;">
              <button
                type="button"
                [disabled]="!financeForm.valid && !showOtpField"
                (click)="handleButtonClick()"
                [disabled]="!buttonEnabled && buttonLabel == 'Verify OTP'"

              >
                {{ buttonLabel }}
              </button>
            </div>
            <div class="form-group col-4" ></div>
          </div>

          <!-- <div class="form-row">
            <div class="form-group" *ngIf="showOtpField">
              <label for="otp">Enter OTP</label>
              <input
                type="text"
                id="otp"
                formControlName="otp"
                placeholder="Enter OTP"
                maxlength="6"
                class="otp-input"
              />
                <p *ngIf="verificationMessage" style="color: green;">{{ verificationMessage }}</p>

            </div>

          </div>

          <div class="form-row">
            <div class="form-group ">
                <button
                  type="button"
                  class="fixed-size-button"
                  [disabled]="!financeForm.valid && !showOtpField"
                  (click)="handleButtonClick()"
                >
                  {{ buttonLabel }}
                </button>
              </div>
          </div> -->




        </form>
    </div>




</div>

<ng-template #successModal>
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content" style="border:none">
        <!-- Modal Header -->
        <div class="modal-header" style="border:none">
          <button
            type="button"
            class="btn-close"
            aria-label="Close"
            (click)="closePopup()"
            style="margin-top: -30px;">
          </button>
        </div>

        <!-- Modal Body -->
        <div class="modal-body">
          <div class="d-flex justify-content-center">
              <img style="height: 150px;width: 150px;margin-bottom: 20px;" [src]='environment1 + "assets/images/success.svg"' alt="">
            </div>
            <h2 class="text-center text-dark fw-bold mb-4">Enquiry Submitted</h2>
            <h3 class="text-center text-secondary fw-bold mb-4" style="font-size: larger;"> Thank you for your enquiry! Our executive will contact you as soon as possible.</h3>
            </div>


      </div>
    </div>
  </ng-template>




